<script lang="ts">
	import { Button } from '$lib/ui/primitives/button';
	import { Hint } from '$lib/ui/atoms/Hint';
	import { getLocale } from '$lib/paraglide/runtime';
	import * as m from '$lib/paraglide/messages';
	import { consentStore } from '$lib/features/consent/logic/consent.store.svelte';

	const privacyHref = getLocale() === 'pl' ? '/pl/privacy' : '/privacy';

	// SML-217: publish the banner's real height (it changes with language and
	// width) so the focused layout can keep its controls clear of it.
	let height = $state(0);
	$effect(() => {
		if (!consentStore.showBanner || height <= 0) return;
		const root = document.documentElement;
		root.style.setProperty('--consent-banner-inset', `${height}px`);
		return () => root.style.removeProperty('--consent-banner-inset');
	});
</script>

{#if consentStore.showBanner}
	<section
		bind:offsetHeight={height}
		class="fixed inset-x-0 bottom-0 z-50 p-3 sm:p-4"
		aria-label={m.consent_banner_aria_label()}
	>
		<div
			class="bg-card text-card-foreground mx-auto flex max-w-3xl flex-col gap-3 rounded-lg border p-4 shadow-lg sm:flex-row sm:items-center sm:justify-between"
		>
			<Hint size="sm" class="block">
				{m.consent_banner_message()}
				<a href={privacyHref} class="text-foreground underline underline-offset-2">
					{m.consent_banner_privacy_link()}
				</a>
			</Hint>
			<div class="flex shrink-0 gap-2">
				<Button variant="outline" size="sm" onclick={() => consentStore.decline()}>
					{m.consent_banner_decline()}
				</Button>
				<Button size="sm" onclick={() => consentStore.accept()}>
					{m.consent_banner_accept()}
				</Button>
			</div>
		</div>
	</section>
{/if}
